module.exports = __webpack_public_path__ + "img/seven4Red.7a6c0e38.jpg";